<style lang="scss" scoped>

</style>
<template>
    <div class="input-group">
        <button @click="toogleChecked" type="button" class="btn form-control" :class="{'btn-info': checked_ }" :disabled="disabled" >
            <slot v-if="!checked_ || !$slots.isChecked"></slot>
            <slot v-if="checked_ && !!$slots.isChecked" name="isChecked"></slot> 
        </button>
        <span class="input-group-text">
            <input @click="checkAllowed" class="form-check-input m-0" v-model="checked_" type="checkbox" :disabled="disabled">
        </span>
    </div>
</template>
<script>

export default {
    name: 'Button Check Box',
    components: {
        
    },
    inject: [
        'state'
    ],
    props: {
        checked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            checked_: false
        }
    },
    computed: {
       
    },
    methods: {
        checkAllowed: function (event) { 
           // eslint-disable-next-line
            if(event.target.checked === true && false){
                event.preventDefault();
            }
        },
        toogleChecked: function (event) {
            event.target.blur();
            event.preventDefault();
           
            if ( this.checked === true ) {
                this.checked_ = false;
            } else {
                this.checked_ = true;
            }
        }
    },
    watch: {
        checked: function (new_value, old_value) {
            if ( new_value !== old_value ) {
                this.checked_ = this.checked;
            }
        },
        checked_: function (new_value, old_value) {
            if ( new_value !== old_value ) {
                this.$emit('update:checked', this.checked_);
            }
        }
    },
    mounted: function () {
        this.checked_ = this.checked;    
    },
}

</script>